import VueTimeago from "vue-timeago";
import Vue from "vue";

Vue.use(VueTimeago, {
  locale: "en"
});
